import { BrowserModule } from '@angular/platform-browser';
import { NgModule } from '@angular/core';
import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { SofboxModule } from './sofbox/sofbox.module';
import { CreditCardDirectivesModule } from 'angular-cc-library';
import { LandingPageModule } from './landing-page/landing-page.module';
import { RecaptchaModule } from 'ng-recaptcha';
import { HttpClientModule } from '@angular/common/http';
import { NgZorroAntdModule, NZ_I18N, en_US } from 'ng-zorro-antd';
import { Ng4LoadingSpinnerModule } from 'ng4-loading-spinner';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
/** config angular i18n **/
import { registerLocaleData } from '@angular/common';
import en from '@angular/common/locales/en';
registerLocaleData(en);

@NgModule({
  declarations: [
    AppComponent
  ],
  exports: [

  ],
  imports: [
    BrowserModule,
    FormsModule,
    CreditCardDirectivesModule,
    ReactiveFormsModule,
    AppRoutingModule,
    SofboxModule,
    LandingPageModule,
    RecaptchaModule,
    HttpClientModule,
    NgZorroAntdModule,
    Ng4LoadingSpinnerModule.forRoot(),
    BrowserAnimationsModule
  ],
  providers: [
    {
      provide: NZ_I18N,
      useValue: en_US,
    }
  ],
  bootstrap: [AppComponent]
})
export class AppModule { }
